import {routerActions} from 'react-router-redux';
import {UserAuthWrapper} from 'redux-auth-wrapper';

export const UserIsAuthenticated = UserAuthWrapper({
  authSelector: state => state.account,
  authenticatingSelector: state => state.account.attemptingLogin,
  redirectAction: routerActions.replace,
  wrapperDisplayName: 'UserIsAuthenticated',
  predicate: account =>  account.authenticated === true,
  failureRedirectPath: (state, ownProps) => ownProps.location.query.redirect || '/login',
});

export const UserIsNotAuthenticated = UserAuthWrapper({
  authSelector: state => state.account,
  redirectAction: routerActions.replace,
  wrapperDisplayName: 'UserIsNotAuthenticated',
  predicate:  account => account.authenticated === false,
  failureRedirectPath: (state, ownProps) => ownProps.location.query.redirect || '/',
  allowRedirectBack: false
});


/** WEBPACK FOOTER **
 ** ./src/utils/authHelpers.js
 **/